import React from 'react'
import moment from 'moment'

export const convertCSVBilling = (data) => {

    const setPaymentTermPo = (sapno,paymentCode) => {
        const textsplit = sapno.split(',');
        if(textsplit.length == 1){
            let text = '#'+sapno+'-'+ paymentCode
            return text;
        }
        else{
            let text = '';
            console.log('textsplit.length',textsplit.length)
            for(let i = 1; i <= textsplit.length; i++){
                
                if(i != textsplit.length){
                    text += '#'+textsplit[i-1]+'-'+paymentCode+','
                }
                else{
                    text += '#'+textsplit[i-1]+'-'+paymentCode
                }

            }
            return text;

        }
    }

  let res = data.map(x => ({
      ...x,
      specialCr : x.specialCr?'Yes':'No',
      blId : `https://ezprocure.dtgo.com/procurement/billform/${x.blId}`,
      scanQrDate : x.scanQrDate?moment(x.scanQrDate).format('YYYY/MM/DD kk:mm:ss'):'',
      docDate : x.docDate?moment(x.docDate).format('YYYY/MM/DD kk:mm:ss'):'',
      modifiedDate : x.modifiedDate?moment(x.modifiedDate).format('YYYY/MM/DD kk:mm:ss'):'',
      waitforOriginalDocDate : x.waitforOriginalDocDate?moment(x.waitforOriginalDocDate).format('YYYY/MM/DD kk:mm:ss'):'',
      acceptedDate : x.acceptedDate?moment(x.acceptedDate).format('YYYY/MM/DD kk:mm:ss'):'',
      completedDate : x.completedDate?moment(x.completedDate).format('YYYY/MM/DD kk:mm:ss'):'',
      createdDate : x.createdDate?moment(x.createdDate).format('YYYY/MM/DD kk:mm:ss'):'',
      sapPoNo : `#${x.sapPoNo}`,
      estimateDueDate: x.estimateDueDate?moment(x.estimateDueDate).format('YYYY/MM/DD'):'',
      dueDate: x.dueDate?moment(x.dueDate).format('YYYY/MM/DD'):'',
      totalInvoiceAmount: Number.parseFloat(x.totalInvoiceAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      deductDownPayment: Number.parseFloat(x.deductDownPayment).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      invoiceAmt: Number.parseFloat(x.invoiceAmt).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      deductRetentionAmount: Number.parseFloat(x.deductRetentionAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      netAmountAfterDeduct: Number.parseFloat(x.netAmountAfterDeduct).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      submittedDate: x.submittedDate?moment(x.submittedDate).format('YYYY/MM/DD kk:mm:ss'):'',
      paymentCode: x.paymentCode
  }))
  return res
}

export const convertCSVGR = (data) => {
    let res = data.map(x => ({
        ...x,
        specialCr : x.specialCr?'Yes':'No',
        grId : `http://ezprocure.dtgo.com/procurement/goodsServiceReceipt/${x.grId}`,
        docDate : x.docDate?moment(x.docDate).format('YYYY/MM/DD kk:mm:ss'):'',
        posDate : x.posDate?moment(x.posDate).format('YYYY/MM/DD kk:mm:ss'):'',
        modifiedDate : x.modifiedDate?moment(x.modifiedDate).format('YYYY/MM/DD kk:mm:ss'):'',
        createdDate : x.createdDate?moment(x.createdDate).format('YYYY/MM/DD kk:mm:ss'):'',
        poNum : `#${x.poNum}`
    }))
    return res
}